module.exports = __webpack_public_path__ + "img/6ed8c36d57fad8d0f5008f8065809c58.svg";